<template>
  <!-- App.vue -->
  <v-app>
    <!--v-app-bar app dense>
      <app-topbar></app-topbar>
    </v-app-bar>
    <v-navigation-drawer app permanent expand-on-hover v-show="!show">

      <app-sidebar class="sidebar"></app-sidebar>
    </v-navigation-drawer-->

    <!-- Sizes your content based upon application components -->
    <v-container>
      <v-card
        ><v-card-title> {{ title }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-menu
                ref="start"
                v-model="start"
                :close-on-content-click="false"
                :return-value.sync="start_date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="start_date"
                    label="Start Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    required="required"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="start_date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="start = false"> ยกเลิก</v-btn>
                  <v-btn color="success" @click="$refs.start.save(start_date)">
                    ตกลง
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-menu
                ref="end"
                v-model="end"
                :close-on-content-click="false"
                :return-value.sync="end_date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="end_date"
                    ref="end"
                    label="End Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    required="required"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="end_date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="end = false"> ยกเลิก</v-btn>
                  <v-btn color="success" @click="$refs.end.save(end_date)"> ตกลง </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn @click="search" color="success">ค้นหา</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <div id="chart">
            <apex-chart
              type="bar"
              height="350"
              :options="chartOptions"
              :series="series"
              v-if="loaded"
            ></apex-chart>
            <!--vue-frappe
              id="pointflow"
              :labels="labels"
              :title="title"
              type="axis-mixed"
              height="480"
              :colors="['purple', '#ffa3ef']"
              :dataSets="chartData"
              :barOptions="barOptions"
              >></!--vue-frappe
            -->
          </div>
        </v-card-text>
        <v-card-text>
          <v-data-table :headers="headers" :items="pointData" v-if="pointData.length > 0">
            <template v-slot:item.earn="{ item }">
              {{ item.earn | numFormat("0,000,000") }}
            </template>
            <template v-slot:item.redeem="{ item }">
              {{ item.redeem | numFormat("0,000,000") }}
            </template>
          </v-data-table></v-card-text
        >
      </v-card>
    </v-container>
  </v-app>
</template>
<script>
//import VueCharts from "vue-chartjs";
//import { Bar } from "vue-chartjs";
import axios from "axios";
//import AppSideBar from "../menu/sideBarMenu";
//import AppTopBar from "../menu/topBarMenu";
import VueApexCharts from "vue-apexcharts";
//import { VueFrappe } from "vue2-frappe";
//import "zingchart/es6";
// eslint-disable-next-line no-unused-vars
//import zingchartVue from "zingchart-vue";

import { thMonth } from "../../../library/config";

export default {
  components: {
    /*
"app-sidebar": AppSideBar,
    "app-topbar": AppTopBar,
*/
    "apex-chart": VueApexCharts,
    //"vue-frappe": VueFrappe,
    //"zing-chart": zingchartVue,
  },
  //extends: Bar,
  data() {
    return {
      start: "",
      end: "",
      start_date: new Date(new Date().setDate(new Date().getDate() - 30))
        .toISOString()
        .slice(0, 10), //new Date().toISOString().slice(0,10),//.replace(/-/g,""),
      end_date: new Date().toISOString().slice(0, 10), //.replace(/-/g,""),
      headers: [
        { text: "วันที่", value: "_id" },
        { text: "สะสมคะแนน", value: "earn" },
        { text: "แลกรางวัล", value: "redeem" },
      ],
      loaded: false,

      // series: [],
      title: "Point Flow",
      pointData: [],

      series: [
        {
          name: "Earn",
          data: [],
        },
        {
          name: "Redeem",
          data: [],
        },
        {
          name: "Pending",
          data: [],
        },
      ],

      chartOptions: {
        // Line chart
        /*
        chart: {
          height: 950,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#77B6EA", "#545454"],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Point Flow",
          align: "left",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: [],
          title: {
            text: "Date",
          },
        },
        yaxis: {
          title: {
            text: "Points",
          },
          min: 0,
          max: 0,
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },*/
        // Bar Chart

        chart: {
          type: "bar",
          height: 600,
        },
        plotOptions: {
          bar: {
            colors: {
              ranges: [
                {
                  from: -100,
                  to: -46,
                  color: "#F15B46",
                },
                {
                  from: -45,
                  to: 0,
                  color: "#FEB019",
                },
              ],
            },
            columnWidth: "80%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: "Point",
          },
          labels: {
            // eslint-disable-next-line no-unused-vars
            formatter: function (y) {
              return y; //y.toFixed(0) + "%";
            },
          },
        },
        xaxis: {
          //type: "datetime",
          categories: [],
          labels: {
            rotate: -90,
          },
        },
      }, // chartOptions
    };
  },
  mounted() {
    // let day = new Date().getDay();
    // let month = new Date().getMonth() - 1;
    // let year = new Date().getYear();
    // this.start = year + "-" + month + "-" + day;
    //-----------------
    this.search();
  },
  methods: {
    resetChart() {
      console.log("resetChart");
      this.chartOptions = {
        // Line chart
        /*
          chart: {
            height: 950,
            type: "line",
            dropShadow: {
              enabled: true,
              color: "#000",
              top: 18,
              left: 7,
              blur: 10,
              opacity: 0.2,
            },
            toolbar: {
              show: false,
            },
          },
          colors: ["#77B6EA", "#545454"],
          dataLabels: {
            enabled: true,
          },
          stroke: {
            curve: "smooth",
          },
          title: {
            text: "Point Flow",
            align: "left",
          },
          grid: {
            borderColor: "#e7e7e7",
            row: {
              colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          markers: {
            size: 1,
          },
          xaxis: {
            categories: [],
            title: {
              text: "Date",
            },
          },
          yaxis: {
            title: {
              text: "Points",
            },
            min: 0,
            max: 0,
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
            floating: true,
            offsetY: -25,
            offsetX: -5,
          },*/
        // Bar Chart

        chart: {
          type: "bar",
          height: 600,
        },
        plotOptions: {
          bar: {
            colors: {
              ranges: [
                {
                  from: -100,
                  to: -46,
                  color: "#F15B46",
                },
                {
                  from: -45,
                  to: 0,
                  color: "#FEB019",
                },
              ],
            },
            columnWidth: "80%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: "Point",
          },
          labels: {
            // eslint-disable-next-line no-unused-vars
            formatter: function (y) {
              return y; //y.toFixed(0) + "%";
            },
          },
        },
        xaxis: {
          //type: "datetime",
          categories: [],
          labels: {
            rotate: -90,
          },
        },
      }; // chartOptions
    },
    async search() {
      //------------------------
      // Overwriting base render method with actual data.
      // this.renderChart({
      //   labels: [
      //     "January",
      //     "February",
      //     "March",
      //     "April",
      //     "May",
      //     "June",
      //     "July",
      //     "August",
      //     "September",
      //     "October",
      //     "November",
      //     "December",
      //   ],
      //   datasets: [
      //     {
      //       label: "GitHub Commits",
      //       backgroundColor: "#f87979",
      //       data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11],
      //     },
      //   ],
      // });
      console.log("search");
      //async () => {
      console.log("call point flow");
      const url = process.env.VUE_APP_LOYALTY_API_URI;
      this.loaded = false;

      try {
        //
        let earnPoint;
        let redeemPoint;
        let pendingPoint;
        let payloadBody = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
          start: this.start_date,
          end: this.end_date,
        };
        axios
          .post(
            url + "/v1/report/pointFlow",
            payloadBody // need to change
          )
          .then((response) => {
            console.log(typeof response.data);
            this.pointData = [];
            this.resetChart();
            this.series = [
              {
                name: "Earn",
                data: [],
              },
              {
                name: "Redeem",
                data: [],
              },
              {
                name: "Pending",
                data: [],
              },
            ];

            if (response.status == 200) {
              earnPoint = response.data.earnPoint.map((item) => {
                let formattedId = "";
                let ymd = item._id.split("-");
                formattedId = ymd[2] + " " + thMonth[parseInt(ymd[1]) - 1] + " " + ymd[0];
                return { sum: item.sum, _id: formattedId };
              }); //

              console.log(earnPoint);
              pendingPoint = response.data.pendingPoint.map((item) => {
                let formattedId = "";
                let ymd = item._id.split("-");
                formattedId = ymd[2] + " " + thMonth[parseInt(ymd[1]) - 1] + " " + ymd[0];
                return { sum: item.sum, _id: formattedId };
              }); //
              console.log(pendingPoint);

              redeemPoint = response.data.redeemPoint.map((item) => {
                let formattedId = "";
                let ymd = item._id.split("-");
                formattedId = ymd[2] + " " + thMonth[parseInt(ymd[1]) - 1] + " " + ymd[0];
                return { sum: item.sum, _id: formattedId };
              }); //
              console.log(redeemPoint);
              //this.pointData = { redeemPoint: redeemPoint, earnPoint: earnPoint };
              console.log(earnPoint.length);
              if (earnPoint.length >= redeemPoint.length) {
                //---------------------------
                for (let i = 0; i < earnPoint.length; i++) {
                  this.chartOptions.xaxis.categories.push(earnPoint[i]._id);
                  if (this.chartOptions.yaxis.max < earnPoint[i].sum) {
                    this.chartOptions.yaxis.max = earnPoint[i].sum;
                  }
                  if (redeemPoint[i] == undefined) {
                    redeemPoint[i] = {
                      sum: 0,
                    };
                  }
                  if (this.chartOptions.yaxis.min > redeemPoint[i].sum) {
                    this.chartOptions.yaxis.min = redeemPoint[i].sum;
                  }

                  if (pendingPoint[i] == undefined) {
                    pendingPoint[i] = {
                      sum: 0,
                    };
                  }
                  if (this.chartOptions.yaxis.min > pendingPoint[i].sum) {
                    this.chartOptions.yaxis.min = pendingPoint[i].sum;
                  }

                  this.series[0].data.push(earnPoint[i].sum);
                  this.series[1].data.push(redeemPoint[i].sum);
                  this.series[2].data.push(pendingPoint[i].sum);
                  this.pointData.push({
                    _id: earnPoint[i]._id,
                    earn: earnPoint[i].sum,
                    redeem: redeemPoint[i].sum,
                  });
                  console.log(this.pointData);
                }
                //----------------------
              } else {
                //---------------------
                for (let i = 0; i < redeemPoint.length; i++) {
                  this.chartOptions.xaxis.categories.push(redeemPoint[i]._id);
                  if (this.chartOptions.yaxis.max < redeemPoint[i].sum) {
                    this.chartOptions.yaxis.max = redeemPoint[i].sum;
                  }
                  if (earnPoint[i] == undefined) {
                    earnPoint[i] = {
                      sum: 0,
                    };
                  }
                  if (this.chartOptions.yaxis.min > earnPoint[i].sum) {
                    this.chartOptions.yaxis.min = earnPoint[i].sum;
                  }

                  this.series[0].data.push(redeemPoint[i].sum);
                  this.series[1].data.push(earnPoint[i].sum);
                  this.pointData.push({
                    _id: redeemPoint[i]._id,
                    earn: redeemPoint[i].sum,
                    redeem: earnPoint[i].sum,
                  });
                }
                console.log(this.pointData);
                //-------------------------
              }
              /*
                for (let i = 0; i < earnPoint.length; i++) {
                  this.chartOptions.xaxis.categories.push(earnPoint[i]._id);
                  if (this.chartOptions.yaxis.max < earnPoint[i].sum) {
                    this.chartOptions.yaxis.max = earnPoint[i].sum;
                  }
                  if(redeemPoint[i] == undefined){
                    redeemPoint[i] = {
                      sum : 0
                      };
                  }
                  if (this.chartOptions.yaxis.min > redeemPoint[i].sum) {
                    this.chartOptions.yaxis.min = redeemPoint[i].sum;
                  }

                  this.series[0].data.push(earnPoint[i].sum);
                  this.series[1].data.push(redeemPoint[i].sum);
                  this.pointData.push({
                    _id: earnPoint[i]._id,
                    earn: earnPoint[i].sum,
                    redeem: redeemPoint[i].sum,
                  });
                }
                */

              console.log(this.chartOptions.xaxis);
              // */
              // for (let i = 0; i < earnPoint.length; i++) {
              //   //this.chartOptions.xaxis.categories.push(data.earnPoint[i]._id);
              //   this.chartData.scaleX.values.push(response.data.earnPoint[i]._id);

              //   //this.chartData[0].values.push(earnPoint[i].sum);
              //   //this.chartData[1].values.push(redeemPoint[i].sum);
              // }
              console.log(this.chartOptions);
              if (this.chartOptions.xaxis.categories.length > 0) {
                this.loaded = true;
              }
            }
          });
        //console.log(_Clients);
        //return _Clients;
      } catch (err) {
        console.log(err);
      }
    },
    //------------------------
  },
};
</script>
<style scoped></style>
